import ElasticProcessor from '@lib/processors/elastic-processor'
import LogStatus from './log-status.vue'

const TABLE_FILTERS = [
  {
    attribute: 'createdAt',
    label: 'Date Created',
    type: 'date',
    icon: 'el-icon-date',
  },
  {
    attribute: 'requestMethod',
    // label: 'Product Description',
    type: 'select',
    // type: 'string',
    icon: 'el-icon-data-line',
    values: [
      {
        value: 'GET',
        label: 'GET',
      },
      {
        value: 'POST',
        label: 'POST',
      },
      {
        value: 'PUT',
        label: 'PUT',
      },
      {
        value: 'DELETE',
        label: 'DELETE',
      },
      {
        value: 'PATCH',
        label: 'PATCH',
      },
    ],
  },
  {
    attribute: 'requestPath',
    type: 'string',
    icon: 'el-icon-data-line',
  },
  {
    attribute: 'createdBy.lastName',
    label: 'Updated By',
    type: 'string',
    icon: 'el-icon-user',
    customFiltering(filter) {
      const { comparison, value } = filter
      const lowercasedValue = (value || '').toLowerCase()
      let source = 'String s = doc["createdBy.firstName.lowercase"].value; s += " "; s += doc["createdBy.lastName.lowercase"].value; '

      switch (comparison) {
        case 'contains':
          source += `s.contains("${lowercasedValue}")`
          break
        case 'doesnt_contain':
          source += `!s.contains("${lowercasedValue}")`
          break
        case 'eq':
          source += `s.equalsIgnoreCase("${lowercasedValue}")`
          break
        case 'starts':
          source += `s.startsWith("${lowercasedValue}")`
          break
        case 'ends':
          source += `s.endsWith("${lowercasedValue}")`
          break
      }

      return {
        script: {
          script: {
            lang: 'painless',
            source,
            params: { ...filter },
          },
        },
      }
    },
  },
  {
    attribute: 'responseStatusCode',
    label: 'Status',
    type: 'select',
    icon: 'el-icon-circle-check',
    values: [
      {
        value: '200',
        label: '200 Ok',
      },
      {
        value: '201',
        label: '201 Created',
      },
      {
        value: '202',
        label: '202 Accepted',
      },
      {
        value: '301',
        label: '301 Moved Permanently',
      },
      {
        value: '302',
        label: '302 Found',
      },
      {
        value: '304',
        label: '304 Not Modified',
      },
      {
        value: '400',
        label: '400 Bad Request',
      },
      {
        value: '401',
        label: '401 Unauthorized',
      },
      {
        value: '403',
        label: '403 Forbidden',
      },
      {
        value: '404',
        label: '404 Not Found',
      },
      {
        value: '500',
        label: '500 Internal Server Error',
      },
      {
        value: '502',
        label: '502 Bad Gateway',
      },
    ],
  },
]

const TABLE_COLUMNS = [
  {
    name: 'createdAt',
    label: 'Date Created',
    icon: 'el-icon-date',
    format: {
      name: 'date',
      params: ['DD/MM/YYYY hh:mm A'],
    },
    width: 150,
  },
  {
    name: 'requestMethod',
    icon: 'el-icon-data-line',
    width: 90,
  },
  {
    name: 'requestPath',
    icon: 'el-icon-data-line',
    width: 200,
  },
  {
    name: 'createdBy.lastName',
    label: 'Updated By',
    icon: 'el-icon-user',
    width: 160,
    format: (_, row) => {
      const { firstName, lastName } = row.createdBy || {}

      return `${firstName} ${lastName}`
    },
    sorting: order => ({
      type: 'string',
      order,
      script: {
        lang: 'painless',
        source: 'doc["createdBy.lastName.lowercase"] + " " + doc["createdBy.firstName.lowercase"]',
      },
    }),
  },
  {
    name: 'responseStatusCode',
    label: 'Status',
    icon: 'el-icon-circle-check',
    format: {
      name: 'capital',
    },
    width: 100,
    component: value => ({
      is: LogStatus,
      props: {
        status: value,
      },
    }),
  },
]

export default function(component) {
  return {
    processor: new ElasticProcessor({
      component,
      index: 'api-logs',
      headers: {
        'Provider-Id': 'null',
      },
      initialDataQuery: {
        defaultSort: {
          createdAt: 'desc',
        },
      },
    }),
    filters: TABLE_FILTERS,
    columns: TABLE_COLUMNS,
    tableName: 'providers',
  }
}
